(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/draw.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/draw.js'); 
'use strict';

const isDrawOpen = currentDraw => currentDraw && currentDraw.drawStateId === 2;
const isCurrentJoker = _ref => {
  let {
    jokerCurrentDraw,
    openTime,
    closeTime
  } = _ref;
  const jokerOpenTime = new Date(jokerCurrentDraw.regOpenTime);
  openTime = new Date(openTime);
  if (openTime.getDate() === jokerOpenTime.getDate()) {
    return true;
  }
  closeTime = new Date(closeTime);
  if (closeTime.getDate() === jokerOpenTime.getDate()) {
    return false;
  }

  const jokerCloseTime = new Date(jokerCurrentDraw.regCloseTime);
  if (closeTime.getDate() === jokerCloseTime.getDate()) {
    return true;
  }
};
const calcLastDrawDate = (drawCount, firstDrawDate, daysBetweenDraws) => {
  const date = new Date(firstDrawDate);
  date.setDate(date.getDate() + (drawCount - 1) * daysBetweenDraws);
  return date;
};
class Draw {
  constructor(_ref2) {
    let {
      currentDraw = {},
      futureDraws = {},
      jokerDraw,
      dateToday,
      daysBetweenDraws = 7
    } = _ref2;
    this.daysBetweenDraws = daysBetweenDraws;
    this.isOpen = currentDraw;
    this.openTime = currentDraw;
    this.drawNumber = currentDraw;
    this.closeTime = currentDraw;
    this.product = futureDraws.productId;
    this.nextOpenTime = futureDraws;
    this.nextDrawNumber = futureDraws;
    this.firstDrawDate = futureDraws;
    this.wasOpenedToday = dateToday;
    this.isJokerOpen = jokerDraw;
    this.jokerCloseTime = jokerDraw;
    this.jokerDrawNumber = jokerDraw;
    this.nextJokerDrawNumber = jokerDraw;
  }
  get productItsId() {
    return svs.numbergames.productMapping.getProductItsId(this._productDrawId);
  }
  get product() {
    return this._productDrawId;
  }
  set product(product) {
    this._productDrawId = svs.numbergames.productMapping.getProductDrawId(product);
  }
  get isOpen() {
    return this._isOpen;
  }
  set isOpen(currentDraw) {
    this._isOpen = isDrawOpen(currentDraw);
  }
  isProductOpen() {
    return this._isOpen;
  }
  get openTime() {
    return this._openTime;
  }
  set openTime(currentDraw) {
    this._openTime = currentDraw && currentDraw.regOpenTime;
  }
  get drawNumber() {
    return this._drawNum;
  }
  set drawNumber(currentDraw) {
    this._drawNum = currentDraw && currentDraw.drawNumber;
  }
  get closeTime() {
    return this._closeTime;
  }
  set closeTime(currentDraw) {
    this._closeTime = currentDraw && currentDraw.regCloseTime;
  }
  get nextOpenTime() {
    return this._nextOpenTime;
  }
  set nextOpenTime(futureDraws) {
    this._nextOpenTime = futureDraws.nextOpenTime;
  }
  get nextDrawNumber() {
    return this._nextDrawNumber;
  }
  set nextDrawNumber(futureDraws) {
    this._nextDrawNumber = futureDraws.nextDrawNumber;
  }
  get firstDrawDate() {
    return this._firstDrawDate;
  }
  set firstDrawDate(futureDraws) {
    const {
      futureDrawEndDates,
      nextOpenTime
    } = futureDraws;
    if (this.isOpen) {
      this._firstDrawDate = this.closeTime;
    } else if (Array.isArray(futureDrawEndDates)) {
      this._firstDrawDate = futureDrawEndDates[0].date;
    } else {
      const nextDrawDate = new Date(nextOpenTime);
      nextDrawDate.setDate(nextDrawDate.getDate() + this.daysBetweenDraws);
      this._firstDrawDate = nextDrawDate;
    }
  }
  get wasOpenedToday() {
    return this._wasOpenedToday;
  }
  set wasOpenedToday(today) {
    const openDate = new Date(this.openTime);
    today = today ? new Date(today) : new Date();
    this._wasOpenedToday = openDate.getDate() === today.getDate();
  }
  get isJokerOpen() {
    return this._isJokerOpen;
  }
  set isJokerOpen(jokerDraw) {
    this._isJokerOpen = jokerDraw && jokerDraw.currentDraw && this.isOpen && isDrawOpen(jokerDraw.currentDraw) && isCurrentJoker({
      jokerCurrentDraw: jokerDraw.currentDraw,
      openTime: this.openTime,
      closeTime: this.closeTime
    });
  }
  set jokerCloseTime(jokerDraw) {
    var _jokerDraw$currentDra;
    this._jokerCloseTime = jokerDraw === null || jokerDraw === void 0 ? void 0 : (_jokerDraw$currentDra = jokerDraw.currentDraw) === null || _jokerDraw$currentDra === void 0 ? void 0 : _jokerDraw$currentDra.regCloseTime;
  }
  get jokerCloseTime() {
    return this._jokerCloseTime;
  }
  get jokerDrawNumber() {
    return this._jokerDrawNumber;
  }
  set jokerDrawNumber(jokerDraw) {
    this._jokerDrawNumber = this.isJokerOpen && jokerDraw.currentDraw && jokerDraw.currentDraw.drawNumber;
  }
  get nextJokerDrawNumber() {
    return this._nextJokerDrawNumber;
  }
  set nextJokerDrawNumber(jokerDraw) {
    this._nextJokerDrawNumber = jokerDraw && jokerDraw.futureDraws && jokerDraw.futureDraws[0] && jokerDraw.futureDraws[0].nextDrawNumber;
  }
  drawNumbers() {
    return [{
      productItsId: this.productItsId,
      drawNumber: this.drawNumber || this.nextDrawNumber
    }];
  }
  firstAndLastDrawDates(_ref3) {
    let {
      drawCount
    } = _ref3;
    switch (drawCount) {
      case 'subscription':
        return {
          weekday: svs.numbergames.productMapping.getDay(this.product)
        };
      case '1':
        return {
          first: this.firstDrawDate
        };
      default:
        return {
          first: this.firstDrawDate,
          last: calcLastDrawDate(drawCount, this.firstDrawDate, this.daysBetweenDraws)
        };
    }
  }
}
svs.numbergames.draws = svs.numbergames.draws || {};
svs.numbergames.draws.Draw = Draw;
 })(window);